const Keycodes = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ENTER: 13,
    SPACE: 32,
    ESC: 27,
    BACKSPACE: 8,
};

export default Keycodes;


// WEBPACK FOOTER //
// ./app/b3/utils/KeyCodes.js